// DEPLOY: /var/www/woody.wtf/frontend/src/components/ThematicTags.js
// Tags for an announcement's AI thematics (market.announcements.thematics,
// written by analyse_announcements.py from the admin Thematics prompt), e.g.
// "A.I.", "Gov Backing". Shown after the NoveltyTag on the Company,
// Announcements, AI Audit and Discord Bot pages. Same shape as NoveltyTag,
// in its own colour so a theme stands out. Renders nothing when there are none.
import React from 'react';

const style = {
  display: 'inline-block', marginLeft: '6px', verticalAlign: 'middle', whiteSpace: 'nowrap',
  fontFamily: "'DM Mono', monospace", fontSize: '9px', letterSpacing: '0.06em', lineHeight: 1.4, fontWeight: 600,
  padding: '0 5px', borderRadius: 'var(--radius)', border: '1px solid #0F766E', color: '#0F766E', background: '#CCFBF1',
};

export default function ThematicTags({ t }) {
  return (t || []).map(x => (
    <span key={x} style={style} title="Thematic - matches a statement in the Thematics prompt">{x}</span>
  ));
}
